import React, { useState, useContext } from "react";
import {
  Box,
  Typography,
  TextField,
  CssBaseline,
  Button,
  Card,
  CardContent,
  Grid,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import UserContext from "../../context/UserContext";
import Axios from "axios";
import config from "../../config/Config";

import styles from "./Auth.module.css";

const Login = () => {
  const navigate = useNavigate();
  const { setUserData } = useContext(UserContext);

  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const onChangeUsername = (e) => {
    const newUsername = e.target.value;
    setUsername(newUsername);
  };

  const onChangePassword = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const newUser = { username, password };
    const url = config.base_url + "/api/auth/login";
    const loginRes = await Axios.post(url, newUser);

    if (loginRes.data.status === "fail") {
      setUsernameError(loginRes.data.message);
      setPasswordError(loginRes.data.message);
    } else {
      setUserData(loginRes.data);
      localStorage.setItem("auth-token", loginRes.data.token);
      navigate("/");
    }
  };

  return (
    <div className={styles.background}>
      <CssBaseline />
      <Grid
        spacing={0}
      >
        <Grid xs={12} sm={8} md={6} lg={4}>
          <Box boxShadow={1}>
            <Card className={styles.paper}>
              <CardContent>
                <Typography component="h1" variant="h5">
                  Login
                </Typography>
                <form className={styles.form} onSubmit={onSubmit}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    label="Username"
                    name="username"
                    autoComplete="username"
                    error={usernameError.length > 0 ? true : false}
                    helperText={usernameError}
                    value={username}
                    onChange={onChangeUsername}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    error={passwordError.length > 0 ? true : false}
                    helperText={passwordError}
                    value={password}
                    onChange={onChangePassword}
                  />
                  <Box display="flex" justifyContent="center">
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={styles.submit}
                    >
                      Login
                    </Button>
                  </Box>
                </form>
                <Grid container justify="center">
                  <Grid item>
                    <Link href="/register" variant="body2">
                      Need an account?
                    </Link>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
